import React, { Component } from 'react';
import FormattedLink from '../Parts/FormattedLink';
import { hasClass, addClass, removeClass } from '../../utils/dom';
import s from './Footer.scss';

class Footer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			subMenuOpen: false,
		}
	}

	render() {
		const { setup, navigation } = this.props;
		const { subMenuOpen } = this.state;
		if (setup.static === undefined || setup.siteClosed || setup.shopClosed) return null;
		const footerNavigation = navigation !== undefined ? navigation.footer : [];

		const closeSideMenuHandler = () => {
			const $html = document.querySelector('html');
			removeClass($html, 'is-menuOpen');
			removeClass($html, 'is-subMenuOpen');
			this.setState({ subMenuOpen: false });
		};

		const ourPoliciesHandler = (e) => {
			e.preventDefault();
			const $html = document.querySelector('html');
			if (hasClass($html, 'is-subMenuOpen')) {
				removeClass($html, 'is-subMenuOpen');
				this.setState({ subMenuOpen: false });
			} else {
				addClass($html, 'is-subMenuOpen');
				this.setState({ subMenuOpen: true });
			}
		};

		return (
			<footer className={s.footer}>
				<div className={s.footer_mobileMenu}>
					<a href="#open-our-policies-mobile" onClick={ourPoliciesHandler}>{ setup.static.ourPolicies }</a>
				</div>
				<ul className={s.footer_menu}>
					{ footerNavigation.map((item) => {
						const itemClasses = [s.footer_menu_item];
						if (`/${item.URI}` === window.location.pathname) itemClasses.push(s.footer_menu_item__selected);
						return <li key={item.name} className={itemClasses.join(' ')}><FormattedLink item={item} internal eventHandler={closeSideMenuHandler} /></li>;
					}) }
				</ul>
			</footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/Footer.jsx